<!--

Start View
==========

Everything relevant for the party should be available from this starting page!

-->


<template>
  <div>
    <div>
      <ActiveNewsletters/>
      <SoldOut v-if="soldOut"/>
      <article class="accent-didi">
        <header>
          <h1 class="title">
            {{$t('letter.title')}}
          </h1>
          <p class="subtitle">
            {{$t('letter.subtitle')}}
          </p>
        </header>
        <main>
          <img src="../assets/fdx_180410.db073ca.svg" class="didi" />
          <p>{{$t('letter.text[0]')}}</p>
          <p>{{$t('letter.text[1]')}}</p>
          <p>{{$t('letter.text[2]')}}</p>
          <i18n path="letter.text[3]" tag="p">
            <template #abdl_link>
              <router-link :to="{name: 'faq'}">{{$t('letter.abdl_link')}}</router-link>
            </template>
          </i18n>
          <i18n path="letter.text[4]" tag="p">
            <template #party_date>
              <i18n path="letter.party_date" tag="strong">
                <template v-slot:nextPartyDay>{{ nextPartyDate.day }}</template>
                <template v-slot:nextPartyMonth>{{ $t(`monthNames[${nextPartyDate.month - 1}]`) }}</template>
                <template v-slot:nextPartyYear>{{ nextPartyDate.year }}</template>
              </i18n>
            </template>
            <template #underground_link>
              <a href="https://www.mlc-munich.de/web/partys-events/underground/">{{$t('letter.underground_link')}}</a>
            </template>
            <template #mlc_link>
              <a href="https://www.mlc-munich.de/">{{$t('letter.mlc_link')}}</a>
            </template>
          </i18n>
          <p>{{$t('letter.text[5]')}}</p>
          <p>{{$t('letter.text[6]')}}</p>
          <img src="../assets/ingat.regular.png" height="20px" style="margin-top: 20px; filter: invert()">
        </main>
      </article>
      <article class="accent-patricia">
        <header>
          <h2>Meine erste Fetischparty</h2>
          <p class="subtitle">
            Soll ich da hingehen? Ich war noch nie auf so einer Party.
          </p>
        </header>
        <main>
          <p>
            Bestimmt hast du viele Vorurteile, Scheu oder Hemmungen, wenn du noch nie auf einer ABDL oder einer anderen Fetisch-Party warst. Da kann ich dich aber beruhigen. Die Party ist wesentlich harmloser, als viele sich das vorstellen. Es sind ganz normale Menschen dort, die sich unterhalten, lachen, gemeinsam etwas trinken und sich hin und wieder wickeln. Man kommt relativ leicht mit anderen Leuten ins Gespräch, da alle ein gemeinsames Interesse an dem ABDL Thema haben. Du kannst frei entscheiden, was du alles ausprobieren möchtest. Schau es dir am Anfang einfach an und unterhalte dich mit den Leuten. Und wenn du mehr ausprobieren möchtest, dann steht dem nichts im Wege ;-)
          </p>
          <p>
            Am Freitag zum Meet&Greet begrüßen wir auch alle Frechdaxe, die kein Ticket mehr für die Hauptveranstaltungen bekommen konnten. Du kannst auch gerne einfach auf einen entspannten Abend vorbei kommen und direkt mit anderen Frechdaxen oder dem Team ins Gespräch kommen. Sieh dir vorab auch gerne die
            <router-link :to="{name: 'party'}">Räumlichkeiten</router-link>
            an, um ein Gefühl dafür zu bekommen, was dich auf der Party selbst erwartet.
          </p>
          <p>
            Für alle weiteren Fragen rund um das Thema Party und ABDL steht dir das Frechdax-Team zur Verfügung - gehe dazu einfach auf unser
            <router-link :to="{ name: 'contact' }">Kontaktformular</router-link>
            und schicke eine digitale Postkarte direkt ans Team!
          </p>
        </main>
      </article>
    </div>
  </div>
</template>

<script>

import SoldOut from '@/components/SoldOut.vue'
import ActiveNewsletters from '@/components/newsletter/ActiveNewsletters.vue'

export default {
  components: {
    SoldOut,
    ActiveNewsletters,
  },
  data() {
    return {
      soldOut: process.env.VUE_APP_TICKETS_AVAILABLE !== 'true',
      nextPartyDate: JSON.parse(process.env.VUE_APP_PARTY_DATE)
    };
  },
}

</script>


<style scoped lang="scss">
.start {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1em;
}

img.didi {
  padding: 0;
  float: right;
  background: #bbdefb;
  width: 160px;
  margin-top: -60px;
  margin-bottom: 20px;
  margin-left: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  position: relative;

  @media screen and (max-width: 1000px) {
    margin-top: 0;
    margin-left: 0;
  }
}
</style>

<i18n>
{
  "de": {
    "letter": {
      "title": "Darf ich mich vorstellen?",
      "subtitle": "Dax mein Name. Dietmar \"Didi\" Dax.",
      "abdl_link": "ABDL",
      "party_date": "{nextPartyDay}. {nextPartyMonth} {nextPartyYear}",
      "underground_link": "UnderGround (UG)",
      "mlc_link": "Münchner Löwen Club e.V. (MLC)",
      "text": [
        "Ich bin ehrlich gesagt wahnsinnig aufgeregt, denn endlich ist es wieder soweit:",
        "Die nächste ABDL-Party in München öffnet seine Pforten! Und du bist herzlich eingeladen!",
        "Meine Freunde und ich - zu meinen Ehren liebevoll das Team frɘchdax - haben uns aus den verschiedensten Ecken des Landes zusammengetan und uns das Ziel gesetzt, mit euch gemeinsam einen unvergesslichen Abend veranstalten zu können. Denn jedes Mal, wenn wir uns treffen, finden wir neue Leute, mit denen wir feiern und den Tag genießen können. Dabei vergessen wir nie, was uns zusammen gebracht hat!",
        "Nachdem wir also bei so manchen {abdl_link}-Meetups quer übers Land verteilt eine Menge Spaß hatten, ist uns eine Sache aufgefallen: Bei uns in der eigenen Heimat sucht man vergeblich nach einer guten und einfachen Möglichkeit, Gleichgesinnte zu treffen und sich auszutauschen. Darum haben wir uns den festen Plan gepackt, unsere Erfahrungen mitzunehmen und \"daheim\" ebenso einmalige Momente zu schaffen. Damit geben wir endlich auch für den südlichen Teil des Landes jedem \"frɘchdax\" einen Platz zu feiern.",
        "Packt eure Kalender aus und streicht euch den {party_date} farbig an! Dort werdet ihr uns in den Räumlichkeiten des {underground_link} - dem Clublokal unseres Veranstaltungspartners, dem {mlc_link} - finden.",
        "Ich freue mich riesig auf euch! Wir sehen uns in München!",
        "Euer"
      ]
    },
    "letter_to_the_team": "Postkarte an Didi"
  },

  "en": {
    "letter": {
      "title": "May I Announce Myself?",
      "subtitle": "Dax my Name. Dietmar \"Didi\" Dax.",
      "party_date": "{nextPartyMonth} {nextPartyDay}, {nextPartyYear}",
      "text": [
        "Let me honest, I am massively thrilled because finally the time has come:",
        "The first ABDL-Party in Munich is soon opening their doors! And I am pleased to invite you!",
        "My friends and I - together to my honor \"Team frɘchdax\" - have gathered from around the country and had one goal: Making it possible to have a memorable evening with you. Because everytime we meet, we find new folks to celebrat and enjoy the day. After all, we don't forget what brought us together!",
        "So, after having plenty amounts of fun at various {abdl_link}-Meetups distributed all over the country, we realized one thing: At our own homeland you won't find any good and easy opportunity to meet and commute with like-minded people. That's why we conceived the steady plan to take our experiences from these occasions. And with that to build up unique moments in the same manner. We are pleased to finally offer a place to get together with other \"frɘchdax's\" in the southern part of the republic.",
        "Take out your calendars and colorfully mark the {party_date}! Then you will find us in the rooms of the {underground_link} - the club location of our event partner, the {mlc_link}.",
        "I am eager to see you soon in Munich!",
        "Your"
      ]
    },
    "letter_to_the_team": "Post Card to Didi"
  }
}
</i18n>
<i18n src="@/locales/global.json"/>
